import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { CapabilitiesService } from '../shared-context/capabilities.service';
import { ClassNames } from './icon-font-classes.utility';
import { IconFontType } from './icon-font-type.enum';

@Component({
    selector: 'ohp-icon-font',
    templateUrl: './icon-font.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconFontComponent implements OnInit, OnChanges {
    @Input() public color: string;
    @Input() public cssClass: string;
    @Input() public iconFontCssClass: string;
    @Input() public iconFontName: string;
    @Input() public iconFontType: IconFontType;
    @Input() public id: string;
    @Input() public size: number;
    @Input() public style: string;
    @Input() public title: string;
    @Input() public ariaVisible: boolean;
    @Input() public ariaLabel: string;
    @Input() public dataArea: string;
    @Input() public dataNav: boolean;
    @Input() public iconButton: boolean;
    @Input() public isThirdParty: boolean;
    @Input() public focusOnLoad: boolean;

    @Output() public readonly iconClicked: EventEmitter<void> = new EventEmitter<void>();
    // We don't have input values for iconAriaLabel and tabIndex because we are marking the span within the icon-font as aria-hidden="true"
    // in order to circumvent some weird narrator issues where we will scan the same thing multiple times if it belongs to nested elements

    public classAttrValue: string;
    public styleAttrValue: Object;

    constructor(
        private readonly capabilitiesService: CapabilitiesService
    ) {
    }

    public ngOnInit() {
        this.classAttrValue = this.getClasses();
        this.styleAttrValue = this.getStyle();
    }

    public ngOnChanges(changesObj: SimpleChanges) {
        if (changesObj.hasOwnProperty('iconFontCssClass') ||
            changesObj.hasOwnProperty('iconFontType') ||
            changesObj.hasOwnProperty('iconFontName') ||
            changesObj.hasOwnProperty('cssClass')) {
            this.classAttrValue = this.getClasses();
        }
        if (changesObj.hasOwnProperty('size') || changesObj.hasOwnProperty('color')) {
            this.styleAttrValue = this.getStyle();
        }
    }

    public handleClick() {
        this.iconClicked.emit();
    }

    private getClasses(): string {
        let cssClass = this.iconFontCssClass ? this.iconFontCssClass : ClassNames.FluentIconCssClass;
        const useSvg = this.capabilitiesService.capabilities.svgAppIconsEnabled;
        if (!this.iconFontCssClass) {
            // Use icon font name to select a css class if possible. If iconFont name is missing then use iconFontType.
            if (this.iconFontName) {
                cssClass += ` ${ClassNames.getCssClassFromGlyphName(this.iconFontName, useSvg)}`;
            } else if (typeof this.iconFontType !== 'undefined') {
                cssClass += ` ${ClassNames.getCssClass(this.iconFontType, useSvg)}`;
            }
        }

        if (this.cssClass) {
            cssClass += ` ${this.cssClass}`;
        }

        if (this.isThirdParty) {
                cssClass += ' ms-ohp-Icon';
        }

        return cssClass;
    }

    private getStyle(): Object {
        const style = this.style ? this.style : {};

        if (this.size) {
            style['font-size'] = `${this.size}px`;
        }

        if (this.color) {
            style['color'] = this.color;
        }

        return style;
    }
}
